import React, { useMemo, useState, useEffect, forwardRef } from "react";
import { Input, InputProps, type InputRef } from "antd";

interface StyledTextInputProps extends InputProps {}

const StyledTextInput = forwardRef<InputRef, StyledTextInputProps>(
  ({ className, value, defaultValue, onChange, ...props }, ref) => {
    const isControlled = value !== undefined;
    const [uncontrolledValue, setUncontrolledValue] = useState<string>(
      defaultValue?.toString() ?? ""
    );

    useEffect(() => {
      if (!isControlled) {
        setUncontrolledValue(defaultValue?.toString() ?? "");
      }
    }, [defaultValue, isControlled]);

    const currentValue = isControlled ? value : uncontrolledValue;
    const hasValue = useMemo(() => {
      if (currentValue === undefined || currentValue === null) {return false;}
      if (Array.isArray(currentValue)) {return currentValue.length > 0;}
      return String(currentValue).length > 0;
    }, [currentValue]);

    return (
      <Input
        {...props}
        ref={ref}
        value={isControlled ? value : uncontrolledValue}
        onChange={event => {
          if (!isControlled) {
            setUncontrolledValue(event.target.value);
          }
          onChange?.(event);
        }}
        className={`styled-text-input ${hasValue ? "styled-text-input--has-value" : ""} ${
          className || ""
        }`}
      />
    );
  }
);

StyledTextInput.displayName = "StyledTextInput";

export default StyledTextInput;
